import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { KlmrTakeTemplatePage } from './klmr-take-template';

@NgModule({
  declarations: [
    KlmrTakeTemplatePage,
  ],
  imports: [
    IonicPageModule.forChild(KlmrTakeTemplatePage),
  ],
})
export class KlmrTakeTemplatePageModule {}



// WEBPACK FOOTER //
// ./src/pages/klmr-take-template/klmr-take-template.module.ts